module.exports = __webpack_public_path__ + "media/images/kumu-f11da1692dde087aa6fbb79f4d56411a.png";